const prefix = 'FLIGHT_EDIT';
export const createActionTypes = (resource) => ({
    LOAD: `${prefix}/${resource}/LOAD'`,
    LOADING: `${prefix}/${resource}/LOADING'`,
    LOADED: `${prefix}/${resource}/LOADED'`,
});
const updateFlightAction = 'UPDATE_FLIGHT';
export const updateFlightActionTypes = {
    UPDATE: `${prefix}${updateFlightAction}/UPDATE`,
    UPDATING: `${prefix}${updateFlightAction}/UPDATING`,
    UPDATED: `${prefix}${updateFlightAction}/UPDATED`,
    CANCEL_UPDATE: `${prefix}${updateFlightAction}/CANCEL_UPDATE`,
    NAVIGATE_TO_DETAILS: `${prefix}${updateFlightAction}/NAVIGATE_TO_DETAILS`,
    NAVIGATED_TO_DETAILS: `${prefix}${updateFlightAction}/NAVIGATED_TO_DETAILS`,
};
// Action Creators
export const updateFlight = (flightId, workspaceId, managementGroup, configuration) => {
    return {
        type: updateFlightActionTypes.UPDATE,
        payload: {
            flightId: flightId,
            workspaceId: workspaceId,
            managementGroup: managementGroup,
            configuration: configuration,
        },
    };
};
export const updatingFlight = (payload) => {
    return {
        type: updateFlightActionTypes.UPDATING,
        payload: payload,
    };
};
export const updatedFlight = (payload, result) => {
    return {
        type: updateFlightActionTypes.UPDATED,
        payload: { result, workspaceId: payload.workspaceId, managementGroup: payload.managementGroup, flightId: payload.flightId },
    };
};
// reset update
export const cancelEdit = (flightId) => {
    return {
        type: updateFlightActionTypes.CANCEL_UPDATE,
        payload: { flightId },
    };
};
export const navigateToDetails = (flightId, workspaceId, managementGroup) => {
    return {
        type: updateFlightActionTypes.NAVIGATE_TO_DETAILS,
        payload: { flightId, workspaceId, managementGroup },
    };
};
export const navigatedToDetails = () => {
    return {
        type: updateFlightActionTypes.NAVIGATED_TO_DETAILS,
        payload: {},
    };
};
export const loadPathsActionTypes = createActionTypes('LOAD_PATHS');
export const loadManagementGroupPaths = (flightId, workspaceId, tenant) => {
    return {
        type: loadPathsActionTypes.LOAD,
        payload: {
            flightId,
            workspaceId,
            tenant,
        },
    };
};
export const loadingManagementGroupPaths = (payload) => {
    return {
        type: loadPathsActionTypes.LOADING,
        payload: { flightId: payload.flightId },
    };
};
export const loadedManagementGroupPaths = (flightId, paths) => {
    return {
        type: loadPathsActionTypes.LOADED,
        payload: {
            flightId,
            paths,
        },
    };
};

//# sourceMappingURL=FlightEdit.ducks.js.map
